import { render, staticRenderFns } from "./NewEventSlat.vue?vue&type=template&id=0091f4c7&scoped=true&"
import script from "./NewEventSlat.vue?vue&type=script&lang=ts&"
export * from "./NewEventSlat.vue?vue&type=script&lang=ts&"
import style0 from "./NewEventSlat.vue?vue&type=style&index=0&id=0091f4c7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0091f4c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
